export const POI_TYPES = {
  MAJOR: 'major',
  MINOR: 'minor',
} as const
